import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 5.5a6 6 0 0 1 6 6H6a6 6 0 0 1 6-6"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.7 8.2a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7M14.3 8.2a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7M7.9 3.3a.7.7 0 0 1 1 .25l1.4 2.3-.9.55L8 4.1a.7.7 0 0 1-.1-.8M16.1 3.3a.7.7 0 0 0-1 .25l-1.4 2.3.9.55L16 4.1a.7.7 0 0 0 .1-.8M6 12.8h12V19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zM3.6 12.4A1.4 1.4 0 0 1 5 13.8v3.4a1.4 1.4 0 0 1-2.8 0v-3.4a1.4 1.4 0 0 1 1.4-1.4M20.4 12.4a1.4 1.4 0 0 1 1.4 1.4v3.4a1.4 1.4 0 0 1-2.8 0v-3.4a1.4 1.4 0 0 1 1.4-1.4"
    }, null, -1)
  ]))]))
}
export default { render: render }